var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@naturehouse/design-system/components/protons/icon/Icon.macro.njk"] = require( "@naturehouse/design-system/components/protons/icon/Icon.macro.njk" );




var shim = require("/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/organisms/card-house__instant-booking.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["tooltip", "id"], 
[], 
function (l_tooltip, l_id, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("tooltip", l_tooltip);
frame.set("id", l_id);
var t_2 = "";t_2 += "\n    ";
env.getTemplate("@naturehouse/design-system/components/protons/icon/Icon.macro.njk", false, "templates/components/organisms/card-house__instant-booking.html.njk", false, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
t_3.getExported(function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
context.setVariable("iconTemplate", t_3);
t_2 += "\n\n    <div class=\"search__result__instant-booking\">\n        <button\n            type=\"button\"\n            class=\"no-button\"\n            data-tool-tip=\"instant-booking-";
t_2 += runtime.suppressValue(l_id, env.opts.autoescape);
t_2 += "\"\n        >\n            ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 9, colno = 34, runtime.callWrap(runtime.memberLookup((t_3),"render"), "iconTemplate[\"render\"]", context, [{"name": "instant-booking","size": "1"}]))), env.opts.autoescape);
t_2 += "\n        </button>\n        ";
t_2 += runtime.suppressValue(env.getFilter("safe").call(context, l_tooltip), env.opts.autoescape);
t_2 += "\n    </div>\n";
})});
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("render");
context.setVariable("render", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/organisms/card-house__instant-booking.html.njk"] , dependencies)